<template>
  <a-config-provider
    :locale="antdLocale"
    :theme="theme"
    :input="input"
    :get-popup-container="getPopupContainer"
    :get-target-container="getTargetContainer"
  >
    <App>
      <router-view />
      <CookieSettings />
    </App>
  </a-config-provider>
</template>


<script setup lang="ts">
import { App, type ConfigProviderProps } from 'ant-design-vue'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import CookieSettings from '@/components/common/cookie-settings.vue'

dayjs.locale('zh-cn')

const antdLocale = zhCN

const theme: ConfigProviderProps['theme'] = {
  token: {
    zIndexPopupBase: 2100
  }
}

const input: ConfigProviderProps['input'] = {
  autocomplete: 'off'
}
const getPopupContainer: ConfigProviderProps['getPopupContainer'] = () => {
  return document.body.querySelector<HTMLElement>('#app')!
}

const getTargetContainer: ConfigProviderProps['getTargetContainer'] = () => {
  return document.body.querySelector<HTMLElement>('#app')!
}
</script>
